import HourlyAbsenceForm, {
  FormData as HourlyFormData,
} from './HourlyAbsenceForm';

import * as yup from 'yup';
import { AbsenceFormProps } from './AbsenceFormProps';
import { useExtraFieldsFormValidationByFormId } from '../ExtraFields/useExtraFieldsFormValidation';
import { ExtraFieldsSupportedObject } from '../ExtraFields';
import { extraFieldsContextParams } from '../ExtraFields';
import { FieldType } from 'server/src/apps/internal-shared/repositoriesShared/EmployeeDataRepositoryBase';
import { useMemo } from 'react';
import Loading from './Loading';
import React from 'react';
import { ExtraFieldsFormId } from '../ExtraFields/types';

const createBaseValidationSchema = () => {
  const baseSchema = {
    startDate: yup.date().required(),
    endDate: yup
      .date()
      .required()
      .when(
        'startDate',
        (startDate: HourlyFormData['startDate'], schema: yup.DateSchema) => {
          if (startDate) {
            return schema.min(startDate);
          }
          return schema;
        },
      ),
    note: yup
      .string()
      .notRequired()
      .when('$requireNote', (requireNote, schema) => {
        if (requireNote) {
          return schema.required();
        }
        return schema;
      }),
  };

  return yup.object().shape<HourlyFormData>(baseSchema);
};

export const HourlyAbsenceFormWithExtraFields: React.FC<AbsenceFormProps> = (
  props,
) => {
  const { applyExtraFieldsValidationSchema, loading } =
    useExtraFieldsFormValidationByFormId({
      objectApiName: ExtraFieldsSupportedObject.Absence,
      formId: ExtraFieldsFormId.AbsencesRequestAbsence,
      contextParams: [
        {
          name: extraFieldsContextParams.absenceRequestForm.absenceCategoryName,
          type: FieldType.String,
          value: props.categoryName,
        },
      ],
    });

  // it is super important to never change validationSchemaWithExtraFields property, otherwise validation is broken
  const validationSchemaWithExtraFields = useMemo(
    () => applyExtraFieldsValidationSchema(createBaseValidationSchema()),
    [applyExtraFieldsValidationSchema],
  );

  if (loading) {
    return (
      <Loading
        absenceCategoriesGroupSelect={props.absenceCategoriesGroupSelect}
        absenceCategorySelect={props.absenceCategorySelect}
      />
    );
  }

  return (
    <HourlyAbsenceForm
      {...props}
      validationSchema={validationSchemaWithExtraFields}
    />
  );
};
